<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import OnboardingStepCard from './OnboardingStepCard.vue';

const getters = useStoreGetters();
const { t } = useI18n();
const globalConfig = computed(() => getters['globalConfig/get'].value);
const currentUser = computed(() => getters.getCurrentUser.value);

const greetingParams = computed(() => ({
  name: currentUser.value.name,
  installationName: globalConfig.value.installationName,
}));

const greetingMessage = computed(() => {
  const hours = new Date().getHours();
  if (hours < 12) return t('ONBOARDING.GREETING_MORNING', greetingParams.value);
  if (hours < 18)
    return t('ONBOARDING.GREETING_AFTERNOON', greetingParams.value);
  return t('ONBOARDING.GREETING_EVENING', greetingParams.value);
});

const STEPS = [
  {
    title: 'Crie sua caixa de entrada',
    description:
      'Conecte um canal — WhatsApp, e-mail ou chat — para começar a receber mensagens.',
    cta: 'Criar caixa de entrada',
    to: 'settings_inbox_new',
  },
  {
    title: 'Convide sua equipe',
    description:
      'Adicione agentes pelo e-mail para que possam atender e colaborar nas conversas.',
    cta: 'Convidar agentes',
    to: 'agent_list',
  },
  {
    title: 'Configure respostas prontas',
    description:
      'Crie atalhos de resposta para agilizar o atendimento. Digite "/" em qualquer conversa para usar.',
    cta: 'Criar respostas prontas',
    to: 'canned_list',
  },
  {
    title: 'Organize com etiquetas',
    description:
      'Crie etiquetas para categorizar e filtrar conversas por tipo de atendimento.',
    cta: 'Criar etiquetas',
    to: 'labels_list',
  },
];
</script>

<template>
  <div class="flex items-center justify-center w-full h-full overflow-auto">
    <div class="w-full max-w-2xl px-8 py-12 flex flex-col gap-8">
      <div class="flex flex-col gap-1">
        <p
          class="text-xl font-semibold text-n-slate-12 font-interDisplay tracking-tight"
        >
          {{ greetingMessage }}
        </p>
        <p class="text-sm text-n-slate-10">
          {{ $t('ONBOARDING.SETUP_SUBTITLE') }}
        </p>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <OnboardingStepCard
          v-for="(step, index) in STEPS"
          :key="step.to"
          :step="index + 1"
          :title="step.title"
          :description="step.description"
          :cta="step.cta"
          :to="step.to"
        />
      </div>
    </div>
  </div>
</template>
